import createNotification from 'components/Settings/Utilities/CreateNotification';

function fallbackCopyTextToClipboard(text, successMessage) {
  let tempInput = document.createElement('input');
  tempInput.style = 'position: absolute; left: -1000px; top: -1000px;';
  tempInput.value = text;
  document.body.appendChild(tempInput);
  tempInput.select();
  try {
    document.execCommand('copy');
    createNotification('success', successMessage ?? 'Text copied');
  } catch (err) {}
  document.body.removeChild(tempInput);
}
function copyTextToClipboard(text, successMessage) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      createNotification('success', successMessage ?? 'Text copied');
    },
    function (err) {}
  );
}

function copyInnerHtml(content, text, successMessage) {
  const { ClipboardItem } = window;
  try {
    const normalizedText = text.replace(/\r?\n/g, '\r\n');
    const blobInputHTML = new Blob([content], { type: 'text/html' });
    const blobInputPlainText = new Blob([normalizedText], { type: 'text/plain' });
    const clipboardItemInputHTML = new ClipboardItem({
      'text/html': blobInputHTML,
      'text/plain': blobInputPlainText,
    });
    navigator.clipboard.write([clipboardItemInputHTML]).then(
      function () {
        createNotification('success', successMessage ?? 'Text copied');
      },
      function (err) {}
    );
  } catch (e) {}
}

function copyTableClean(element, successMessage) {
  const { ClipboardItem } = window;

  const clone = element.cloneNode(true);
  const strip = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    node.removeAttribute('class');
    node.removeAttribute('style');
    node.removeAttribute('id');
    Array.from(node.children).forEach(strip);
  };
  strip(clone);

  const cleanHtml = clone.outerHTML;

  const rows = element.querySelectorAll('tr');
  const tsv = Array.from(rows)
    .map((row) =>
      Array.from(row.querySelectorAll('th, td'))
        .map((cell) => cell.innerText.replace(/\t/g, ' ').replace(/\r?\n/g, ' '))
        .join('\t')
    )
    .join('\r\n');

  try {
    const blobHtml = new Blob([cleanHtml], { type: 'text/html' });
    const blobText = new Blob([tsv], { type: 'text/plain' });
    navigator.clipboard.write([new ClipboardItem({ 'text/html': blobHtml, 'text/plain': blobText })]).then(
      function () {
        createNotification('success', successMessage ?? 'Table copied');
      },
      function () {}
    );
  } catch (e) {}
}

const handleCopyClickPrevElement = (e) => {
  const text = e.currentTarget?.previousElementSibling?.textContent?.trim();
  if (text) copyTextToClipboard(text);
};

export { copyTextToClipboard, copyInnerHtml, copyTableClean, handleCopyClickPrevElement };
